// Digest: 738a4d1746340798f5f393cb464c2238befcfaaa
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface _Types {
  IndexProps: ServerTemplatesIndex;
  BasicResponseProps: ClassTrackerViewsInterfacesResponseBasicResponse;
  RespSchoolsTermsUpdateProps: ClassTrackerViewsInterfacesResponseRespSchoolsTermsUpdate;
  RespSubjectsUpdateProps: ClassTrackerViewsInterfacesResponseRespSubjectsUpdate;
  RespGetSchoolsProps: ClassTrackerViewsInterfacesResponseRespGetSchools;
  RespGetSubjectsProps: ClassTrackerViewsInterfacesResponseRespGetSubjects;
  RespRefreshCourseSectionsProps: ClassTrackerViewsInterfacesResponseRespRefreshCourseSections;
  RespGetRecipientFormProps: ClassTrackerViewsInterfacesResponseRespGetRecipientForm;
  RespEditRecipientProps: ClassTrackerViewsInterfacesResponseRespEditRecipient;
  RespGetCourseSectionsProps: ClassTrackerViewsInterfacesResponseRespGetCourseSections;
  RespAddWatchedSectionProps: ClassTrackerViewsInterfacesResponseRespAddWatchedSection;
  ClassTrackerLoginProps: ClassTrackerViewsTemplatesClassTrackerLogin;
  ClassTrackerIndexProps: ClassTrackerViewsTemplatesClassTrackerIndex;
  ClassTrackerManageCourselistProps: ClassTrackerViewsTemplatesClassTrackerManageCourselist;
  ClassTrackerAddClassesProps: ClassTrackerViewsTemplatesClassTrackerAddClasses;
  ClassTrackerClassAlertsProps: ClassTrackerViewsTemplatesClassTrackerClassAlerts;
  BlankResponseProps: DiscordTrackerViewsInterfacesResponseBlankResponse;
  SchoolSelectionResponseProps: DiscordTrackerViewsInterfacesResponseSchoolSelectionResponse;
  ValidateDiscordInviteResponseProps: DiscordTrackerViewsInterfacesResponseValidateDiscordInviteResponse;
  ServerInvitesResponseProps: DiscordTrackerViewsInterfacesResponseServerInvitesResponse;
  SubmitInviteResponseProps: DiscordTrackerViewsInterfacesResponseSubmitInviteResponse;
  GetSubjectsResponseProps: DiscordTrackerViewsInterfacesResponseGetSubjectsResponse;
  GetCoursesResponseProps: DiscordTrackerViewsInterfacesResponseGetCoursesResponse;
  GetInstructorsResponseProps: DiscordTrackerViewsInterfacesResponseGetInstructorsResponse;
  TDiscordInviteDataProps: DiscordTrackerTypedefsDiscordApiTDiscordInviteData;
  DiscordTrackerWelcomeProps: DiscordTrackerViewsTemplatesDiscordTrackerWelcome;
  DiscordTrackerExploreAllProps: DiscordTrackerViewsTemplatesDiscordTrackerExploreAll;
  DiscordTrackerLoginProps: DiscordTrackerViewsTemplatesDiscordTrackerLogin;
  DiscordTrackerProfileProps: DiscordTrackerViewsTemplatesDiscordTrackerProfile;
  DiscordTrackerUnapprovedInvitesProps: DiscordTrackerViewsTemplatesDiscordTrackerUnapprovedInvites;
  DiscordTrackerReferralManagementProps: DiscordTrackerViewsTemplatesDiscordTrackerReferralManagement;
  globals: {
    Widget:
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsTextarea
      | DjangoFormsWidgetsCheckboxInput
      | DjangoFormsWidgetsSelect;
    models: {
      "class_tracker.views.interfaces_response._SchoolPick": ClassTrackerViewsInterfacesResponse_SchoolPick;
      "class_tracker.views.interfaces_response._TermPick": ClassTrackerViewsInterfacesResponse_TermPick;
      "class_tracker.views.interfaces_response._SubjectPick": ClassTrackerViewsInterfacesResponse_SubjectPick;
      "class_tracker.views.interfaces_response._RecipientPick": ClassTrackerViewsInterfacesResponse_RecipientPick;
      "class_tracker.views.interfaces_response._SectionWithInstructorsPick": ClassTrackerViewsInterfacesResponse_SectionWithInstructorsPick;
      "class_tracker.views.templates._SchoolPick": ClassTrackerViewsTemplates_SchoolPick;
      "class_tracker.views.templates._TermPick": ClassTrackerViewsTemplates_TermPick;
      "class_tracker.views.templates._RecipientPick": ClassTrackerViewsTemplates_RecipientPick;
      "class_tracker.views.templates._ClassAlertPick": ClassTrackerViewsTemplates_ClassAlertPick;
      "class_tracker.views.templates._RecipientBasicPick": ClassTrackerViewsTemplates_RecipientBasicPick;
      "discord_tracker.views.interfaces_response._DiscordServerPick": DiscordTrackerViewsInterfacesResponse_DiscordServerPick;
      "discord_tracker.views.interfaces_response._SchoolPick": DiscordTrackerViewsInterfacesResponse_SchoolPick;
      "discord_tracker.views.interfaces_response._DiscordInvitePick": DiscordTrackerViewsInterfacesResponse_DiscordInvitePick;
      "discord_tracker.views.interfaces_response._SubjectPick": DiscordTrackerViewsInterfacesResponse_SubjectPick;
      "discord_tracker.views.interfaces_response._CoursePick": DiscordTrackerViewsInterfacesResponse_CoursePick;
      "discord_tracker.views.interfaces_response._InstructorPick": DiscordTrackerViewsInterfacesResponse_InstructorPick;
      "discord_tracker.views.templates._DiscordServerPick": DiscordTrackerViewsTemplates_DiscordServerPick;
      "discord_tracker.views.templates._DiscordUserProfilePick": DiscordTrackerViewsTemplates_DiscordUserProfilePick;
      "discord_tracker.views.templates._SchoolPick": DiscordTrackerViewsTemplates_SchoolPick;
      "discord_tracker.views.templates._DiscordInvitePick": DiscordTrackerViewsTemplates_DiscordInvitePick;
      "discord_tracker.views.templates._UserReferralPick": DiscordTrackerViewsTemplates_UserReferralPick;
    };
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ServerUtilContextProcessorsUser &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor;
  RPCPermission: null;
}
export interface ServerTemplatesIndex {}
export interface ClassTrackerViewsInterfacesResponseBasicResponse {
  is_success: boolean;
  message: string;
}
export interface ClassTrackerViewsInterfacesResponseRespSchoolsTermsUpdate {
  available_schools: ClassTrackerViewsInterfacesResponse_SchoolPick[];
  available_terms: ClassTrackerViewsInterfacesResponse_TermPick[];
  new_terms_count: number;
}
export interface ClassTrackerViewsInterfacesResponse_SchoolPick {
  id: number;
  name: string;
  globalsearch_key: string;
}
export interface ClassTrackerViewsInterfacesResponse_TermPick {
  id: number;
  name: string;
  year: number;
  globalsearch_key: string;
  full_term_name: string;
}
export interface ClassTrackerViewsInterfacesResponseRespSubjectsUpdate {
  available_subjects: ClassTrackerViewsInterfacesResponse_SubjectPick[];
}
export interface ClassTrackerViewsInterfacesResponse_SubjectPick {
  id: number;
  name: string;
}
export interface ClassTrackerViewsInterfacesResponseRespGetSchools {
  schools: ClassTrackerViewsInterfacesResponse_SchoolPick[];
}
export interface ClassTrackerViewsInterfacesResponseRespGetSubjects {
  subjects: ClassTrackerViewsInterfacesResponse_SubjectPick[];
}
export interface ClassTrackerViewsInterfacesResponseRespRefreshCourseSections {
  courses: Course_124B540953[];
}
export interface Course_124B540953 {
  id: number;
  code: string;
  level: string;
  sections: {
    number: number;
  }[];
}
export interface ClassTrackerViewsInterfacesResponseRespGetRecipientForm {
  recipient_form: ClassTrackerViewsForms;
  contact_info_forms: ClassTrackerViewsForms1[];
  new_contact_info_form: ClassTrackerViewsForms1;
}
export interface ClassTrackerViewsForms {
  name: "class_tracker.views.forms.RecipientForm";
  errors: {
    name?: string[];
    description?: string[];
    is_contact_by_phone?: string[];
  } | null;
  fields: {
    name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    description: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
    is_contact_by_phone: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
  };
  prefix: string;
  iterator: ("name" | "description" | "is_contact_by_phone")[];
  hidden_fields?: ("name" | "description" | "is_contact_by_phone")[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedSerializationWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedSerializationWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedSerializationWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ClassTrackerViewsForms1 {
  name: "class_tracker.views.forms.ContactInfoForm";
  errors: {
    number?: string[];
    is_enabled?: string[];
  } | null;
  fields: {
    number: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    is_enabled: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
  };
  prefix: string;
  iterator: ("number" | "is_enabled")[];
  hidden_fields?: ("number" | "is_enabled")[];
}
export interface ClassTrackerViewsInterfacesResponseRespEditRecipient {
  recipient: ClassTrackerViewsInterfacesResponse_RecipientPick | null;
  recipient_form: ClassTrackerViewsForms | null;
  contact_info_forms: ClassTrackerViewsForms1[] | null;
  new_contact_info_form: ClassTrackerViewsForms1 | null;
}
export interface ClassTrackerViewsInterfacesResponse_RecipientPick {
  id: number;
  name: string;
  phone_numbers: {
    id: number;
    number: string;
  }[];
}
export interface ClassTrackerViewsInterfacesResponseRespGetCourseSections {
  sections: ClassTrackerViewsInterfacesResponse_SectionWithInstructorsPick[];
}
export interface ClassTrackerViewsInterfacesResponse_SectionWithInstructorsPick {
  id: number;
  number: number;
  topic: string;
  course: {
    id: number;
    code: string;
    level: string;
  };
  instruction_entries: {
    instructor: {
      id: number;
      name: string;
    };
  }[];
  instruction_list: ClassTrackerModelsInstructorInfo[];
}
export interface ClassTrackerModelsInstructorInfo {
  name: string;
  days_times: string;
}
export interface ClassTrackerViewsInterfacesResponseRespAddWatchedSection {
  added_section: ClassTrackerViewsInterfacesResponse_SectionWithInstructorsPick;
}
export interface ClassTrackerViewsTemplatesClassTrackerLogin {
  is_invalid_credentials: boolean;
}
export interface ClassTrackerViewsTemplatesClassTrackerIndex {
  title: string;
}
export interface ClassTrackerViewsTemplatesClassTrackerManageCourselist {
  schools: ClassTrackerViewsTemplates_SchoolPick[];
  terms_available: ClassTrackerViewsTemplates_TermPick[];
}
export interface ClassTrackerViewsTemplates_SchoolPick {
  id: number;
  name: string;
  globalsearch_key: string;
}
export interface ClassTrackerViewsTemplates_TermPick {
  id: number;
  name: string;
  year: number;
  globalsearch_key: string;
  full_term_name: string;
}
export interface ClassTrackerViewsTemplatesClassTrackerAddClasses {
  terms_available: ClassTrackerViewsTemplates_TermPick[];
  recipients: ClassTrackerViewsTemplates_RecipientPick[];
}
export interface ClassTrackerViewsTemplates_RecipientPick {
  id: number;
  name: string;
  phone_numbers: {
    id: number;
    number: string;
  }[];
  watched_sections: {
    id: number;
    number: number;
    topic: string;
    course: {
      id: number;
      code: string;
      level: string;
    };
    instruction_entries: {
      instructor: {
        id: number;
        name: string;
      };
    }[];
  }[];
}
export interface ClassTrackerViewsTemplatesClassTrackerClassAlerts {
  title: string;
  class_alerts: ClassTrackerViewsTemplates_ClassAlertPick[];
  recipients: ClassTrackerViewsTemplates_RecipientBasicPick[];
  selected_recipient_id: number;
  pagination: ServerUtilTypedefsTPaginationData;
}
export interface ClassTrackerViewsTemplates_ClassAlertPick {
  id: number;
  datetime_created: string;
  recipient: {
    id: number;
    name: string;
  };
  course_section: {
    id: number;
    number: number;
    topic: string;
    course: {
      id: number;
      code: string;
      level: string;
      subject: {
        name: string;
      };
    };
    term: {
      id: number;
      full_term_name: string;
    };
    instruction_entries: {
      id: number;
      get_days_and_times: string;
      instructor: {
        id: number;
        name: string;
      };
    }[];
  };
}
export interface ClassTrackerViewsTemplates_RecipientBasicPick {
  id: number;
  name: string;
}
export interface ServerUtilTypedefsTPaginationData {
  current_page: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
  previous_page_number: number;
  next_page_number: number;
}
export interface DiscordTrackerViewsInterfacesResponseBlankResponse {}
export interface DiscordTrackerViewsInterfacesResponseSchoolSelectionResponse {
  success: boolean;
  message: string;
}
export interface DiscordTrackerViewsInterfacesResponseValidateDiscordInviteResponse {
  guild_info: DiscordTrackerViewsInterfacesResponseTSimpleGuildInfo | null;
  existing_server_info: DiscordTrackerViewsInterfacesResponse_DiscordServerPick | null;
  available_schools: DiscordTrackerViewsInterfacesResponse_SchoolPick[];
  is_new_server: boolean;
}
export interface DiscordTrackerViewsInterfacesResponseTSimpleGuildInfo {
  id: string;
  name: string;
  icon_url: string;
}
export interface DiscordTrackerViewsInterfacesResponse_DiscordServerPick {
  id: number;
  server_id: string;
  name: string;
  display_name: string;
  description: string;
  member_count: number;
  icon_url: string;
  privacy_level_info: DiscordTrackerModelsDiscordServerTServerPrivacyLevel;
  is_active: boolean;
  is_featured: boolean;
  schools: {
    id: number;
    name: string;
  }[];
  subjects: {
    id: number;
    name: string;
  }[];
  courses: {
    id: number;
    code: string;
    level: string;
    title: string;
  }[];
  instructors: {
    id: number;
    name: string;
  }[];
}
export interface DiscordTrackerModelsDiscordServerTServerPrivacyLevel {
  value: "public" | "private";
  label: string;
}
export interface DiscordTrackerViewsInterfacesResponse_SchoolPick {
  id: number;
  name: string;
}
export interface DiscordTrackerViewsInterfacesResponseServerInvitesResponse {
  invites: DiscordTrackerViewsInterfacesResponse_DiscordInvitePick[];
}
export interface DiscordTrackerViewsInterfacesResponse_DiscordInvitePick {
  id: number;
  invite_url: string;
  notes_md: string;
  expires_at: string | null;
  uses_count: number;
  is_valid: boolean;
  is_unlimited: boolean;
}
export interface DiscordTrackerViewsInterfacesResponseSubmitInviteResponse {
  discord_server: DiscordTrackerViewsInterfacesResponse_DiscordServerPick | null;
}
export interface DiscordTrackerViewsInterfacesResponseGetSubjectsResponse {
  subjects: DiscordTrackerViewsInterfacesResponse_SubjectPick[];
  message: string;
}
export interface DiscordTrackerViewsInterfacesResponse_SubjectPick {
  id: number;
  name: string;
}
export interface DiscordTrackerViewsInterfacesResponseGetCoursesResponse {
  courses: DiscordTrackerViewsInterfacesResponse_CoursePick[];
  message: string;
}
export interface DiscordTrackerViewsInterfacesResponse_CoursePick {
  id: number;
  code: string;
  level: string;
  title: string;
}
export interface DiscordTrackerViewsInterfacesResponseGetInstructorsResponse {
  instructors: DiscordTrackerViewsInterfacesResponse_InstructorPick[];
  message: string;
}
export interface DiscordTrackerViewsInterfacesResponse_InstructorPick {
  id: number;
  name: string;
}
export interface DiscordTrackerTypedefsDiscordApiTDiscordInviteData {
  type: number;
  code: string;
  inviter: DiscordTrackerTypedefsDiscordPartialsTBaseUserData;
  expires_at: string | null;
  guild: DiscordTrackerTypedefsDiscordApiTGuildData;
  guild_id: string;
  channel: DiscordTrackerTypedefsDiscordPartialsTChannelData;
  profile: DiscordTrackerTypedefsDiscordApiTGuildProfileData | null;
}
export interface DiscordTrackerTypedefsDiscordPartialsTBaseUserData {
  id: string;
  username: string | null;
  avatar: string | null;
  discriminator: string;
  public_flags: number;
  flags: number;
  banner: string | null;
  accent_color: number | null;
  global_name: string | null;
  avatar_decoration_data: DiscordTrackerTypedefsDiscordPartialsTAvatarDecorationData | null;
  banner_color: string | null;
}
export interface DiscordTrackerTypedefsDiscordPartialsTAvatarDecorationData {
  asset: string;
  sku_id: string;
  expires_at: number | null;
}
export interface DiscordTrackerTypedefsDiscordApiTGuildData {
  id: string;
  name: string;
  splash: string | null;
  banner: string | null;
  description: string | null;
  icon: string | null;
  features: string[];
  verification_level: number;
  vanity_url_code: string | null;
  nsfw_level: number;
  nsfw: boolean;
  premium_subscription_count: number;
}
export interface DiscordTrackerTypedefsDiscordPartialsTChannelData {
  id: string;
  type: number;
  name: string;
}
export interface DiscordTrackerTypedefsDiscordApiTGuildProfileData {
  id: string;
  name: string;
  icon_hash: string;
  member_count: number;
  online_count: number;
  description: string | null;
  banner_hash: string | null;
  game_application_ids: string[];
  game_activity: DiscordTrackerTypedefsDiscordPartialsTGameActivity | null;
  tag: string | null;
  badge: number;
  badge_color_primary: string;
  badge_color_secondary: string;
  badge_hash: string | null;
  traits: string[];
  features: string[];
  visibility: number;
  custom_banner_hash: string | null;
  premium_subscription_count: number;
  premium_tier: number;
}
export interface DiscordTrackerTypedefsDiscordPartialsTGameActivity {}
export interface DiscordTrackerViewsTemplatesDiscordTrackerWelcome {
  servers: DiscordTrackerViewsTemplates_DiscordServerPick[];
  pending_invites_count: number;
}
export interface DiscordTrackerViewsTemplates_DiscordServerPick {
  id: number;
  server_id: string;
  name: string;
  icon_url: string;
  member_count: number;
  privacy_level_info: DiscordTrackerModelsDiscordServerTServerPrivacyLevel1;
  custom_title: string;
  description: string;
  is_active: boolean;
  is_featured: boolean;
  display_name: string;
  is_general_server: boolean;
  subjects: {
    id: number;
    name: string;
  }[];
  courses: {
    id: number;
    code: string;
    level: string;
    title: string;
  }[];
  instructors: {
    id: number;
    name: string;
  }[];
  datetime_established: string | null;
}
export interface DiscordTrackerModelsDiscordServerTServerPrivacyLevel1 {
  value: "public" | "private";
  label: string;
}
export interface DiscordTrackerViewsTemplatesDiscordTrackerExploreAll {
  servers: DiscordTrackerViewsTemplates_DiscordServerPick[];
  pagination: ServerUtilTypedefsTPaginationData | null;
  subject_id: number | null;
  course_id: number | null;
  is_search_active: boolean;
  pending_invites_count: number;
}
export interface DiscordTrackerViewsTemplatesDiscordTrackerLogin {}
export interface DiscordTrackerViewsTemplatesDiscordTrackerProfile {
  discord_user: DiscordTrackerViewsTemplates_DiscordUserProfilePick;
  school: DiscordTrackerViewsTemplates_SchoolPick | null;
  school_form: DiscordTrackerViewsForms;
  show_school_modal: boolean;
}
export interface DiscordTrackerViewsTemplates_DiscordUserProfilePick {
  id: number;
  discord_id: string;
  username: string;
  discriminator: string;
  global_name: string;
  avatar: string;
  is_verified: boolean;
  role_info: DiscordTrackerModelsDiscordUserTUserRole;
  first_login: string;
  last_login: string;
  login_count: number;
  display_name: string;
  avatar_url: string;
}
export interface DiscordTrackerModelsDiscordUserTUserRole {
  value: "regular" | "manager";
  label: string;
}
export interface DiscordTrackerViewsTemplates_SchoolPick {
  id: number;
  name: string;
}
export interface DiscordTrackerViewsForms {
  name: "discord_tracker.views.forms.SchoolSelectionForm";
  errors: {
    school?: string[];
  } | null;
  fields: {
    school: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
  };
  prefix: string;
  iterator: "school"[];
  hidden_fields?: "school"[];
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DiscordTrackerViewsTemplatesDiscordTrackerUnapprovedInvites {
  unapproved_invites: DiscordTrackerViewsTemplates_DiscordInvitePick[];
}
export interface DiscordTrackerViewsTemplates_DiscordInvitePick {
  id: number;
  invite_url: string;
  notes_md: string;
  is_valid: boolean;
  expires_at: string | null;
  datetime_created: string;
  submitter: {
    display_name: string;
    role_info: DiscordTrackerModelsDiscordUserTUserRole1;
  };
  discord_server: {
    display_name: string;
    icon_url: string;
    privacy_level_info: DiscordTrackerModelsDiscordServerTServerPrivacyLevel2;
  };
}
export interface DiscordTrackerModelsDiscordUserTUserRole1 {
  value: "regular" | "manager";
  label: string;
}
export interface DiscordTrackerModelsDiscordServerTServerPrivacyLevel2 {
  value: "public" | "private";
  label: string;
}
export interface DiscordTrackerViewsTemplatesDiscordTrackerReferralManagement {
  referral_form: DiscordTrackerViewsForms1;
  referrals: DiscordTrackerViewsTemplates_UserReferralPick[];
  pagination: ServerUtilTypedefsTPaginationData;
}
export interface DiscordTrackerViewsForms1 {
  name: "discord_tracker.views.forms.ReferralCreationForm";
  errors: {
    max_uses_choice?: string[];
    expiry_timeframe?: string[];
  } | null;
  fields: {
    max_uses_choice: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    expiry_timeframe: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
  };
  prefix: string;
  iterator: ("max_uses_choice" | "expiry_timeframe")[];
  hidden_fields?: ("max_uses_choice" | "expiry_timeframe")[];
}
export interface DiscordTrackerViewsTemplates_UserReferralPick {
  id: number;
  code: UUID;
  max_uses: number;
  num_uses: number;
  datetime_created: string;
  datetime_expires: string | null;
  expiry_timeframe: string;
  is_valid: boolean;
  is_expired: boolean;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ServerUtilContextProcessorsUser {
  user: ServerUtilContextProcessorsUserInfo;
}
export interface ServerUtilContextProcessorsUserInfo {
  name: string;
  is_superuser: boolean;
  is_authenticated: boolean;
  discord_user: DiscordUser_781339A50F | null;
}
export interface DiscordUser_781339A50F {
  id: number;
  discord_id: string;
  username: string;
  discriminator: string;
  global_name: string;
  avatar: string;
  is_verified: boolean;
  first_login: string;
  last_login: string;
  login_count: number;
  display_name: string;
  avatar_url: string;
  token_expires_at: string | null;
  is_token_expired: boolean;
  can_refresh_token: boolean;
  role_info: DiscordTrackerModelsDiscordUserTUserRole2;
  is_manager: boolean;
}
export interface DiscordTrackerModelsDiscordUserTUserRole2 {
  value: "regular" | "manager";
  label: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as IndexImplementation} from "@client/templates/Index"
export type IndexCheck = Checker<_Types["IndexProps"], typeof IndexImplementation>;

export namespace templates {
    export type Index = _Types["IndexProps"];
}


        



import {Template as ClassTrackerLoginImplementation} from "@client/templates/ClassTrackerLogin"
export type ClassTrackerLoginCheck = Checker<_Types["ClassTrackerLoginProps"], typeof ClassTrackerLoginImplementation>;

export namespace templates {
    export type ClassTrackerLogin = _Types["ClassTrackerLoginProps"];
}


        



import {Template as ClassTrackerIndexImplementation} from "@client/templates/ClassTrackerIndex"
export type ClassTrackerIndexCheck = Checker<_Types["ClassTrackerIndexProps"], typeof ClassTrackerIndexImplementation>;

export namespace templates {
    export type ClassTrackerIndex = _Types["ClassTrackerIndexProps"];
}


        



import {Template as ClassTrackerManageCourselistImplementation} from "@client/templates/ClassTrackerManageCourselist"
export type ClassTrackerManageCourselistCheck = Checker<_Types["ClassTrackerManageCourselistProps"], typeof ClassTrackerManageCourselistImplementation>;

export namespace templates {
    export type ClassTrackerManageCourselist = _Types["ClassTrackerManageCourselistProps"];
}


        



import {Template as ClassTrackerAddClassesImplementation} from "@client/templates/ClassTrackerAddClasses"
export type ClassTrackerAddClassesCheck = Checker<_Types["ClassTrackerAddClassesProps"], typeof ClassTrackerAddClassesImplementation>;

export namespace templates {
    export type ClassTrackerAddClasses = _Types["ClassTrackerAddClassesProps"];
}


        



import {Template as ClassTrackerClassAlertsImplementation} from "@client/templates/ClassTrackerClassAlerts"
export type ClassTrackerClassAlertsCheck = Checker<_Types["ClassTrackerClassAlertsProps"], typeof ClassTrackerClassAlertsImplementation>;

export namespace templates {
    export type ClassTrackerClassAlerts = _Types["ClassTrackerClassAlertsProps"];
}


        



import {Template as DiscordTrackerWelcomeImplementation} from "@client/templates/DiscordTrackerWelcome"
export type DiscordTrackerWelcomeCheck = Checker<_Types["DiscordTrackerWelcomeProps"], typeof DiscordTrackerWelcomeImplementation>;

export namespace templates {
    export type DiscordTrackerWelcome = _Types["DiscordTrackerWelcomeProps"];
}


        



import {Template as DiscordTrackerExploreAllImplementation} from "@client/templates/DiscordTrackerExploreAll"
export type DiscordTrackerExploreAllCheck = Checker<_Types["DiscordTrackerExploreAllProps"], typeof DiscordTrackerExploreAllImplementation>;

export namespace templates {
    export type DiscordTrackerExploreAll = _Types["DiscordTrackerExploreAllProps"];
}


        



import {Template as DiscordTrackerLoginImplementation} from "@client/templates/DiscordTrackerLogin"
export type DiscordTrackerLoginCheck = Checker<_Types["DiscordTrackerLoginProps"], typeof DiscordTrackerLoginImplementation>;

export namespace templates {
    export type DiscordTrackerLogin = _Types["DiscordTrackerLoginProps"];
}


        



import {Template as DiscordTrackerProfileImplementation} from "@client/templates/DiscordTrackerProfile"
export type DiscordTrackerProfileCheck = Checker<_Types["DiscordTrackerProfileProps"], typeof DiscordTrackerProfileImplementation>;

export namespace templates {
    export type DiscordTrackerProfile = _Types["DiscordTrackerProfileProps"];
}


        



import {Template as DiscordTrackerUnapprovedInvitesImplementation} from "@client/templates/DiscordTrackerUnapprovedInvites"
export type DiscordTrackerUnapprovedInvitesCheck = Checker<_Types["DiscordTrackerUnapprovedInvitesProps"], typeof DiscordTrackerUnapprovedInvitesImplementation>;

export namespace templates {
    export type DiscordTrackerUnapprovedInvites = _Types["DiscordTrackerUnapprovedInvitesProps"];
}


        



import {Template as DiscordTrackerReferralManagementImplementation} from "@client/templates/DiscordTrackerReferralManagement"
export type DiscordTrackerReferralManagementCheck = Checker<_Types["DiscordTrackerReferralManagementProps"], typeof DiscordTrackerReferralManagementImplementation>;

export namespace templates {
    export type DiscordTrackerReferralManagement = _Types["DiscordTrackerReferralManagementProps"];
}


        



export namespace interfaces {
    export type BasicResponse = _Types["BasicResponseProps"];
}


        



export namespace interfaces {
    export type RespSchoolsTermsUpdate = _Types["RespSchoolsTermsUpdateProps"];
}


        



export namespace interfaces {
    export type RespSubjectsUpdate = _Types["RespSubjectsUpdateProps"];
}


        



export namespace interfaces {
    export type RespGetSchools = _Types["RespGetSchoolsProps"];
}


        



export namespace interfaces {
    export type RespGetSubjects = _Types["RespGetSubjectsProps"];
}


        



export namespace interfaces {
    export type RespRefreshCourseSections = _Types["RespRefreshCourseSectionsProps"];
}


        



export namespace interfaces {
    export type RespGetRecipientForm = _Types["RespGetRecipientFormProps"];
}


        



export namespace interfaces {
    export type RespEditRecipient = _Types["RespEditRecipientProps"];
}


        



export namespace interfaces {
    export type RespGetCourseSections = _Types["RespGetCourseSectionsProps"];
}


        



export namespace interfaces {
    export type RespAddWatchedSection = _Types["RespAddWatchedSectionProps"];
}


        



export namespace interfaces {
    export type BlankResponse = _Types["BlankResponseProps"];
}


        



export namespace interfaces {
    export type SchoolSelectionResponse = _Types["SchoolSelectionResponseProps"];
}


        



export namespace interfaces {
    export type ValidateDiscordInviteResponse = _Types["ValidateDiscordInviteResponseProps"];
}


        



export namespace interfaces {
    export type ServerInvitesResponse = _Types["ServerInvitesResponseProps"];
}


        



export namespace interfaces {
    export type SubmitInviteResponse = _Types["SubmitInviteResponseProps"];
}


        



export namespace interfaces {
    export type GetSubjectsResponse = _Types["GetSubjectsResponseProps"];
}


        



export namespace interfaces {
    export type GetCoursesResponse = _Types["GetCoursesResponseProps"];
}


        



export namespace interfaces {
    export type GetInstructorsResponse = _Types["GetInstructorsResponseProps"];
}


        



export namespace interfaces {
    export type TDiscordInviteData = _Types["TDiscordInviteDataProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

